module.exports = __webpack_public_path__ + "static/media/taraDefaultTwo.ca7e2669.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/taraDefaultTwo.svg
// module id = 612
// module chunks = 0